import { COMMON_JS_SEARCH_QUERY_GENERIC } from './commonJsIndex';

export const SITE_URL = 'https://www.inmobiliarianucleo.com';
export const BLOG_URL = `${SITE_URL}/blog`;

export const ROSSETA_LOCALE_KEY = 'rosettaLocale';

export const LAST_SEARCHS_KEY = 'lastSearchs';
export const LAST_SEARCHS_MAX_LENGTH = 3;
export const RECOMMENDED_FLATS_MAX_LENGTH = 24;
export const RECOMMENDED_FLATS_PER_SEARCH = 4;

export const SEARCH_BY_COUNTY_KEYWORD = 'provincia';
export const SEARCH_BY_COUNTY_SUFFIX = `-${SEARCH_BY_COUNTY_KEYWORD}`;

export const FLAT_TYPE_GENERIC = 'viviendas';
export const SEARCH_QUERY_GENERIC = COMMON_JS_SEARCH_QUERY_GENERIC;

export const OFFICES_URL_PREFIX = 'inmobiliarias';

export const HEADER_OPTIONS_MAX_LENGTH = 6;

export const SELL_HOUSE_BLOG_URLS: { i18nKey: string; url: string }[] = [
  {
    i18nKey: 'sellInheritedHouse',
    url: 'https://www.inmobiliarianucleo.com/blog/vender-casa-heredada',
  },
  {
    i18nKey: 'sellVpo',
    url:
      'https://www.inmobiliarianucleo.com/blog/como-vender-vivienda-proteccion-oficial',
  },
  {
    i18nKey: 'sellHouseDueToDivorce',
    url: 'https://www.inmobiliarianucleo.com/blog/divorcio-vender-casa',
  },
  {
    i18nKey: 'sellHouseFast',
    url: 'https://www.inmobiliarianucleo.com/blog/como-vender-casa-rapido',
  },
];
